<template>
  <div
    class="hc-art home-border"
    @click.stop="toggleArt"
    :class="[drawerArtStatus ? 'success' : '', errorStatus ? 'error' : '']"
  >
    <template v-if="list.length">
      <ul>
        <li
          v-for="(item, index) in list"
          class="art-info"
          :key="'list' + index"
        >
          <default-content
            :style="item.style"
            :text="item.name"
            :status="true"
          />
        </li>
      </ul>
    </template>
    <template v-else>
      <ul>
        <li
          v-for="(item, index) in defaultList"
          class="art-info"
          :key="'defaultList' + index"
        >
          <default-content :style="item.style" :text="item.name" />
        </li>
      </ul>
    </template>
    <common-template
      :status="drawerArtStatus"
      :list="list"
      @remove="remove"
      @error="error"
      @close="close"
      :maxLen="maxLen"
      ref="drawerArt"
      :submitText="'图片'"
    >
      <div class="draw-title" slot="info">
        <h3>图片</h3>
        <p>图片需配置4张。,名称、图片、链接 均为必填项。</p>
        <p>图片建议尺寸: 248 * 132</p>
      </div>
    </common-template>
  </div>
</template>

<script>
import defaultContent from "../defaultContent.vue";
import { Home } from "@/config/axios/new_api";
import CommonTemplate from "../commonTemplate.vue";
export default {
  components: { defaultContent, CommonTemplate },
  data() {
    return {
      list: [],
      maxLen: 4,
      defaultList: [
        {
          style:
            "background-image: linear-gradient(180deg, #FECEC2 0%, #FB9F8E 100%)",
        },
        {
          style:
            "background-image: linear-gradient(180deg, #FCE8BD 0%, #F8CC89 100%);",
        },
        {
          style:
            "background-image: linear-gradient(180deg, #BAC2FB 0%, #848EF4 100%);",
        },
        {
          style:
            "background-image: linear-gradient(180deg, #C8E5FF 0%, #97C6FD 100%);",
        },
      ],
      drawerArtStatus: false,
      errorStatus: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      Home.getData({ type: 2 }).then((res) => {
        if (Array.isArray(res.data) && res.data.length) {
          this.list = res.data.map((item) => {
            item.name_edit_status = false;
            item.style = `background-image: url(${item.url})`;
            item.directories_name = item.directories_id ? item.file_name : "";
            item.template_name = item.template_id ? item.file_name : "";
            return item;
          });
        }
      });
    },
    remove(newItems) {
      this.list = newItems;
    },
    error(status) {
      // 提交错误信息 需要在轮播图画红线
      this.errorStatus = status;
    },
    editData(newItems, index) {
      this.$set(this.list, index, newItems);
    },
    close() {
      this.drawerArtStatus = false;
      if (this.list.length < 4) {
        this.errorStatus = true;
        this.$message.error("图片需要配置4张");
      } else {
        let list = this.list.filter((item) => {
          if (
            item.url &&
            item.img_name &&
            item.name &&
            ((item.path_type === 1 && item.directories_id) ||
              (item.path_type && item.template_id))
          ) {
            return item;
          }
        });
        if (list.length < this.list.length) {
          this.$refs.drawerArt.save();
          this.errorStatus = true;
        } else {
          this.$refs.drawerArt.save();
          this.errorStatus = false;
        }
      }
    },
    toggleArt() {
      this.drawerArtStatus = true;
    },
    submit() {
      this.$refs.drawerArt.save();
    },
  },
};
</script>

<style lang="scss" scoped>
.hc-art {
  width: 536px;
  height: 304px;
  float: right;
  padding: 0;
  cursor: pointer;
  .art-info {
    width: 248px;
    height: 132px;
    float: left;
    margin: 10px;
  }
}
</style>
